module.exports = __webpack_public_path__ + "static/media/306235.bb2cbd0e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/306235.pdf
// module id = 881
// module chunks = 0